import * as React from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames'
import { css } from 'emotion'

import { Product } from 'even-ts-static'

import { applicationCalculateQuestionMachineConfig } from 'common/actions/application'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { LifeInsuranceQuestionGroups, MappedLifeInsuranceQuestions, MultiProductDispatch } from 'embed/constants'
import { QuestionMachineConfig } from 'embed/constants/life-insurance'
import {
  applicationLifeInsuranceRouterQuestionsMachineConfigSelector,
  applicationLifeInsuranceRouterQuestionsQuestionsSelector,
} from 'embed/selectors/application'
import { loadingSelector } from 'embed/selectors/loading'

import { MultiProductState } from 'embed/reducers'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { RouterQuestions } from './router-questions'

const styles = require('embed/components/LoadingIndicator/styles.scss')

interface StoreProps {
  isLoading: boolean
  questions: MappedLifeInsuranceQuestions
  questionMachineConfig: QuestionMachineConfig | undefined
}

interface DispatchProps {
  dispatchApplicationCalculateQuestionMachineConfig: () => void
}

export interface ParentProps {
  currentStep: number
  groups: LifeInsuranceQuestionGroups
  onBack: () => void
  onBackToStepOne: () => void
  onContinue: () => void
  questions: MappedLifeInsuranceQuestions
  setCurrentRouterStep: (step: number) => void
  setFollowupStep: (step: number) => void
  shouldReplayResponses: boolean
  stepByStepApplicationStepIsValid: boolean
  totalNumberOfSteps: number
}

type Props = ParentProps & StoreProps & DispatchProps

export const UnconnectedRouterQuestionsContainer: React.SFC<Props> = (props) => {
  const {
    dispatchApplicationCalculateQuestionMachineConfig,
    groups,
    isLoading,
    questionMachineConfig,
    questions,
    ...rest
  } = props

  React.useEffect(() => {
    if (groups.length > 0 && questionMachineConfig === undefined) {
      dispatchApplicationCalculateQuestionMachineConfig()
    }
  }, [groups.length])

  return isLoading || questionMachineConfig === undefined ? (
    <Wrapper {...props}>
      <ThemeConsumer>
        {({ ctaStyles }) => (
          <div
            data-test-id="spinner"
            className={classnames(
              styles.spinner,
              css`
                border-left-color: ${ctaStyles?.backgroundColor};
              `,
            )}
          />
        )}
      </ThemeConsumer>
    </Wrapper>
  ) : (
    <RouterQuestions {...rest} questionMachineConfig={questionMachineConfig} questions={questions} />
  )
}

const mapStateToProps = (state: MultiProductState): StoreProps => ({
  isLoading: loadingSelector(state, Product.LifeInsurance),
  questionMachineConfig: applicationLifeInsuranceRouterQuestionsMachineConfigSelector(state),
  questions: applicationLifeInsuranceRouterQuestionsQuestionsSelector(state),
})

const mapDispatchToProps = (dispatch: MultiProductDispatch): DispatchProps => ({
  dispatchApplicationCalculateQuestionMachineConfig: () => dispatch(applicationCalculateQuestionMachineConfig()),
})

export const RouterQuestionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UnconnectedRouterQuestionsContainer)
